import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/authContext'

// const ProtectedRoute = ({ element, role }) => {
//   const { isAuthenticated, user } = useAuth();
//   const location = useLocation();

//   if (!isAuthenticated) {
//     return <Navigate to="/login" state={{ from: location }} />;
//   }

//   if (role && (!user || user.role !== role)) {
//     return <Navigate to="/" />;
//   }

//   return element;
// };

// const ProtectedRoute = ({ element, roles }) => {
//   const { isAuthenticated, user } = useAuth();
//   const location = useLocation();

//   if (!isAuthenticated) {
//     return <Navigate to="/login" state={{ from: location }} />;
//   }

//   if (!user || !roles.some(role => user.roles.includes(role))) {
//     return <Navigate to="/access-denied" />;
//   }  

//   return element;
// };


// export default ProtectedRoute;


const ProtectedRoute = ({ element, role }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const selectedRole = localStorage.getItem("selectedRole");

  // Redirect unauthenticated users to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // Redirect users to select a role if not set
  // if (!user.role) {
  //   return <Navigate to="/choose-role" />;
  // }

  // Restrict access if user role is not allowed
  if (role && (!user || user.role !== role)) {
    return <Navigate to="/" />;
  }

  return element;
};

export default ProtectedRoute;